import IonqLogo from '@assets/ionq-logo.svg?react';
import { Center } from '@chakra-ui/react';
import { ErrorScreen } from '@ionq/legacy-ui';

// Rendered when the mounted remote tree has no match for the current path
// (useRoutes returns null) — the shell owns the 404, the remote stays
// relative. Standard error screen for consistency with every other failure
// surface.
export default function NotFound() {
    return (
        <Center height='100%' width='100%' overflow='auto'>
            <ErrorScreen
                logo={IonqLogo}
                statusCode={404}
                title='Page not found.'
            />
        </Center>
    );
}
